import parseNetworkError from "@utils/parse-network-error";
import * as apiMethods from "@src/services";

const Types = {
  SET_API_CALL_IN_PROGRESS: "SET_API_CALL_IN_PROGRESS",
  SET_GENERAL_ERRORS: "SET_GENERAL_ERRORS",
};

export const state = {
  isAPICallInProgress: false,
  generalErrors: [],
};

export const getters = {};

export const mutations = {
  [Types.SET_API_CALL_IN_PROGRESS]: (state, status) => {
    state.isAPICallInProgress = status;
  },
  [Types.SET_GENERAL_ERRORS]: (state, error) => {
    state.generalErrors.push(error);
  },
};

export const actions = {
  /**
   * Dispatch AJAX calls
   * @param {String} entity e.g. `users`
   * @param {String} action method name eg. `getById`
   */
  async api({ commit }, { entity, action, payload = {}, query, params }) {
    try {
      const response = await apiMethods[entity][action]({
        payload,
        query,
        params,
      });
      return response;
    } catch (error) {
      const errorPayload = {
        [`${entity}_${action}_request`]: parseNetworkError(error),
      };
      commit(Types.SET_GENERAL_ERRORS, errorPayload);
      commit(Types.SET_API_CALL_IN_PROGRESS, false);
    }
    return null;
  },
};
